/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { USER_ROLE } from "@constants/Bookings";
import { CONSTANTS } from "@constants/index";
import { DateFormats } from "@enums/shared.enum";
import { ReservationCardPropsType } from "@models/components/user.model";
import { applyLocalization } from "@services/common.service";

import CancelBooking from "../CancelBooking/CancelBooking";
import ReservationDetails from "../ReservationDetails/ReservationDetails";

const ReservationCard: React.FC<ReservationCardPropsType> = ({
  data,
  getUserBookings,
}) => {
  const { DATE_FORMATS } = CONSTANTS;

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [cancelModal, toggleCancelModal] = useState(false);

  const { t } = useTranslation();

  const isShowDeleteButton =
    data?.role === USER_ROLE.ORGANIZER_ROLE &&
    moment(data?.startDate)
      .startOf(DateFormats.Day)
      .isSameOrAfter(moment().startOf(DateFormats.Day)) &&
    !data?.bookingCanceled &&
    !data?.recursiveBooking &&
    data?.bookingCancelable;

  return (
    <>
      <div
        onClick={() => setShowDetailsModal(true)}
        className="fg-reservations-card"
        data-testid="reservation-card-test"
      >
        <h6>
          {applyLocalization(data?.club?.title)} -{" "}
          {applyLocalization(data?.resource?.title)}{" "}
          {data?.recursiveBooking && (
            <span className="loc-type ms-2">{t("recurring")}</span>
          )}
        </h6>
        <div className="fg-reservations-card-desc">
          <span>
            {moment(
              data?.startDate,
              DATE_FORMATS.YEAR_MONTH_DAY_HYPHEN_FORMAT
            ).format(DATE_FORMATS.DAY_MONTH_YEAR_FORMAT)}
          </span>
          <span>{`${data.startTime} - ${data.endTime}`}</span>
        </div>
        {isShowDeleteButton && (
          <div className="fg-reservations-card-actions">
            <button
              className="btn p-0"
              onClick={e => {
                e.stopPropagation();
                toggleCancelModal(true);
              }}
            >
              <i className="fa-solid fa-trash fg-text-error"> </i>
            </button>
          </div>
        )}
      </div>
      <CancelBooking
        bookingId={data?.bookingId}
        cancelModal={cancelModal}
        getUserBookings={getUserBookings}
        toggleCancelModal={() => toggleCancelModal(false)}
      />
      {showDetailsModal && !cancelModal && (
        <ReservationDetails
          bookingData={{
            bookingId: data?.bookingId,
          }}
          isOpen={showDetailsModal}
          toggleCancelModal={toggleCancelModal}
          toggleOpen={() => setShowDetailsModal(false)}
        />
      )}
    </>
  );
};

export default ReservationCard;
